/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncTodos} from '../api'

export const useMutationSyncTodos = createReactQueryMutationHook('syncTodos', syncTodos)
